import React from 'react';
import PureLDBreadcrumbs from '../../atoms/PureLDBreadcrumbs';
import PureDNBreadcrumbs from '../../atoms/PureDNBreadcrumbs';
import PropTypes from 'prop-types';

const DNBreadcrumbs = ( { paths } ) => {
  return (
    <>
      <PureLDBreadcrumbs paths={paths}/>
      <PureDNBreadcrumbs paths={paths}/>
    </>
  );
};

export { DNBreadcrumbs };
export default DNBreadcrumbs;

DNBreadcrumbs.propTypes = {
  paths: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired
  }))
};

DNBreadcrumbs.defaultProps = {
  paths: []
};